import { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

export const TableViewEdit = ({ title, showState, resetAction, editAction, invalid, children }) => {
  const [show, setShow] = showState;
  // eslint-disable-next-line
  useEffect(() => { resetAction() }, [show])
  return <Modal show={show} onHide={() => setShow(false)} animation={false} size="xl">
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title><br />
    </Modal.Header>
    <Modal.Body>
      {children}
    </Modal.Body>
    <Modal.Footer style={{ justifyContent: "space-between", display: "inline" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "0.5em" }}>
        <div>
          <Button variant="secondary" onClick={resetAction}>Reset</Button>
        </div>
        <div style={{ marginLeft: "1em" }}>
          <span style={{ color: "red" }}>{invalid}</span>
          <Button variant="primary" onClick={editAction} disabled={invalid !== ""}>Save Changes</Button>
        </div >
      </div>
    </Modal.Footer>
  </Modal>
}

// Default method for performing the resetAction
export const defaultReset = (form, origData) => {
  return () => {
    for (const key in form) {
      const [, setData] = form[key]
      setData(origData[key]);
    }
  }
}

export const defaultEdit = (id, form, submitMethod, updateMethod, setShow) => {
  return async () => {
    const submitForm = {}
    for (const key in form) {
      submitForm[key] = form[key][0]
    }
    await submitMethod(id, submitForm).then(setTimeout(async () => { await updateMethod() }, 200));
    setShow(false);
  }
}

export const defaultValidateEdit = (errors) => {
  return () => {
    for (const x of Object.values(errors)) {
      if (x[0] !== "") return "Form contains errors"
    }
    return ""
  }
}

export default TableViewEdit
